var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.options,"disabled":_vm.computedDisabled,"value":_vm.value},on:{"input":(value) => _vm.$emit('input', value),"change":(value) => _vm.$emit('change', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }